import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import RenderMappings from "./RenderMappings";
import { Loading } from "../Loading";

import { useCmsHook } from "../../helpers/cmsHook";

function MappingWindow({
  mapping,
  hubspotDropdownFields,
  tripletexDropdownFields,
  mappingsFor,
  hubspotLoading,
  txLoading,
  path,
}) {
  const { cmsInstance } = useCmsHook();

  return (
    <div>
      {hubspotLoading || txLoading ? (
        <Loading />
      ) : (
        <Container className="px-0">
          <Row>
            <Col>
              <div>
                <div style={{ marginTop: "29px" }}>
                  {cmsInstance &&
                    cmsInstance.showRichText(
                      path,
                      "mapping-window-text-container"
                    )}
                </div>
              </div>

              <RenderMappings
                mapping={mapping}
                hubspotDropdownFields={hubspotDropdownFields}
                tripletexDropdownFields={tripletexDropdownFields}
                mappingsFor={mappingsFor}
              />
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
}

export default MappingWindow;
